var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lad-facebook-widget"},[_c('h3',[_vm._v(_vm._s(_vm.$t(`${_vm.base}.join_group`)))]),_vm._v(" "),_c('div',{staticClass:"fb-group",attrs:{"data-href":_vm.groupUrl,"data-width":_vm.widgetWidth,"data-show-metadata":true,"data-show-social-context":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }